import { render, staticRenderFns } from "./CheckoutCardData.vue?vue&type=template&id=5d5c97b8"
import script from "./CheckoutCardData.vue?vue&type=script&lang=js"
export * from "./CheckoutCardData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports